import React from "react";
import classNames from "../classNames";

const defaultProps = {
    size: "sm",
}

function Spinner({className, ...props}) {
    const size = 'spinner-border-' + props.size;
    const classes = classNames("spinner-border text-secondary", size, className)
    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className={classes} role="status"/>
        </div>
    )
}

Spinner.defaultProps = defaultProps;
export default Spinner;
